export default (range) => ({
    key: range.endKey,
    offset: range.endOffset,
});
